/**
 * Light Loox iframe polish. No window.message listener (iframes spam postMessage
 * and caused main-thread loops). No aggressive polling.
 */
(function () {
  function polish(root) {
    if (!root) return;
    root.querySelectorAll('iframe').forEach(function (frame) {
      frame.style.display = 'block';
      frame.style.width = '100%';
      frame.style.maxWidth = '100%';
      frame.style.border = '0';
    });
  }

  function run() {
    polish(document.getElementById('looxCarousel'));
    document.querySelectorAll('.loox-v2-carousel-container, .bubs-loox-carousel').forEach(polish);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* One short retry if Loox injects late — then stop */
  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    run();
    if (tries >= 8) clearInterval(timer);
  }, 500);
})();
